import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import type { DefaultComponentProps } from '../../types';
import { hasColor, padding, space } from './helpers';

export interface BlockProps extends DefaultComponentProps {
  _center?: boolean;
  _right?: boolean;
  _noShrink?: boolean;
  _column?: boolean;
  _grow?: boolean;
  _between?: boolean;
  _backgroundColor?: string;
  _space?: number;
}

export const BlockPrimitive = forwardRef<HTMLDivElement, BlockProps>(
  ({ _backgroundColor, children, ...forwardingProps }, ref) => {
    if (_backgroundColor) {
      return (
        <OuterBlock
          {...forwardingProps}
          ref={ref}
          _backgroundColor={_backgroundColor}
        >
          {children}
        </OuterBlock>
      );
    }

    return (
      <RegularBlock {...forwardingProps} ref={ref}>
        {children}
      </RegularBlock>
    );
  }
);

export const Block = styled.div<BlockProps>`
  box-sizing: border-box;
  display: flex;
  position: relative;

  ${({ _column }) =>
    _column &&
    css`
      flex-direction: column;
    `};

  ${({ _center }) =>
    _center &&
    css`
      justify-content: center;
    `}

  ${({ _right }) =>
    _right &&
    css`
      justify-content: flex-end;
    `}

  ${({ _noShrink }) =>
    _noShrink &&
    css`
      flex-shrink: 0;
    `}

  ${({ _grow }) =>
    _grow &&
    css`
      flex-grow: 1;
    `}

  ${({ _between }) =>
    _between &&
    css`
      justify-content: space-between;
    `}

  ${({ _backgroundColor, _space }) =>
    hasColor(_backgroundColor) &&
    css`
      background: ${_backgroundColor};
      padding: ${space(_space)}px ${padding(_space)}px;
    `}
`;

export const RegularBlock = styled(Block)``;

export const OuterBlock = styled(Block)``;
